import { useGlobal } from '@/utils/useGlobal';
import { useEffect } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.G');
    /* eslint-disable */
    const videoLists: any = [
        {
            id: 1,
            title: t('title1'),
            desc: t.rich('desc1', {
                s: (text: string) => <span className="black">{text}</span>,
            }),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768963083544/7_1.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768963083369/7_1-h5.jpg',
            },
        },
        {
            id: 2,
            title: t('title2'),
            desc: t.rich('desc2', {
                s: (text: string) => <span className="black">{text}</span>,
            }),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768963084456/7_2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768963084621/7_2-h5.jpg',
            },
        },
        {
            id: 3,
            title: t('title3'),
            desc: t.rich('desc3', {
                s: (text: string) => <span className="black">{text}</span>,
            }),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768963084069/7_3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768963084249/7_3-h5.jpg',
            },
        },
        {
            id: 4,
            title: t('title4'),
            desc: t.rich('desc4', {
                s: (text: string) => <span className="black">{text}</span>,
            }),
            img: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1768963083716/7_4.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1768963083897/7_4-h5.jpg',
            },
        },
    ];
    /* eslint-disable */
    useEffect(() => {
        const AniContainer = window?.AniContainer;
        AniContainer.create({
            asyncFromTo: [
                ['.power-ocean-home-G .swiper-list-1 .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.6],

                ['.power-ocean-home-G .swiper-list-1 .video-box', { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 0.0001],
                ['.power-ocean-home-G .swiper-list-2 .video-box', { opacity: 0, y: 0 }, { opacity: 1, y: -0 }, 0.0001],
                ['.power-ocean-home-G .swiper-list-2 .text-box', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 0.6],

                ['.power-ocean-home-G .swiper-list-2 .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.6],

                ['.power-ocean-home-G .swiper-list-2 .video-box', { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 0.0001],
                ['.power-ocean-home-G .swiper-list-3 .video-box', { opacity: 0, y: 0 }, { opacity: 1, y: -0 }, 0.0001],
                ['.power-ocean-home-G .swiper-list-3 .text-box', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 0.6],

                ['.power-ocean-home-G .swiper-list-3 .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -150 }, 0.6],

                ['.power-ocean-home-G .swiper-list-3 .video-box', { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 0.0001],
                ['.power-ocean-home-G .swiper-list-4 .video-box', { opacity: 0, y: 0 }, { opacity: 1, y: -0 }, 0.0001],
                ['.power-ocean-home-G .swiper-list-4 .text-box', { opacity: 0, y: 150 }, { opacity: 1, y: 0 }, 0.6],
            ],
            aysnvTimeLine: [0, 0.6, 0.6, 0.6, 1.5, 2, 2, 2, 3, 3, 3, 3.4],
            triggerElement: '.power-ocean-home-G',
            triggerHook: 1,
            offset: '100%',
            duration: '400%',
            scrollUpdatePos: true,
        });

        AniContainer.create({
            syncFromTo: [['.power-ocean-home-G', { y: 0 }, { y: -240 }]],
            triggerElement: '.power-ocean-home-F .img-box',
            triggerHook: 0,
            offset: 0,
            duration: '100%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`power-ocean-home-G ${styles['power-ocean-home-G']}`}>
            <div className="sec7">
                <div className="sticky">
                    <div className="swiper-box">
                        <ul className="swiper-lists">
                            {videoLists?.map((item: any) => (
                                <li className={`swiper-list swiper-list-${item.id}`} key={item.id}>
                                    <div className="list-inner">
                                        <div className="text-box">
                                            <h2 className="title">{item.title}</h2>
                                            <p className="desc">{item.desc}</p>
                                        </div>
                                        <div className="video-box">
                                            <EcoImg pc={item.img?.pc} pad={item.img?.h5} alt={item.title} aria-label={item.title} />
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
